module.exports = __webpack_public_path__ + "img/product-overlay.c67c387.png";